import React from "react";
const EnvContext = /*#__PURE__*/React.createContext({
  API_HOST: "",
  ENTITY_PREFIX: "parcels"
});
export const EnvProvider = EnvContext.Provider;
export const useEnvContext = () => React.useContext(EnvContext);
export const withEnvContext = () => Component => props => /*#__PURE__*/React.createElement(EnvContext.Consumer, null, /*#__PURE__*/React.createElement(Component, props));